<mat-horizontal-stepper
  class="hide-stepper-header" linear="true" #homestepper>
  <mat-step completed="true">
    <section class="bg-magenta bg-portal hero-portal">
      <div class="container hero-content">
        <img
          width="172"
          height="48"
          class="hero-logo"
          ngSrc="../../../../../assets/img/bg-white-logo.png"
          alt="Logo Banco Guayaquil"
        />
        <h1 class="text-prewrap hero-text">Bienvenido al Portal de Seguros para Clientes Banco Guayaquil</h1>
      </div>
    </section>
    <div class="bg-white mt-0">
      <section class="container container-portal">
        <h2 #typeTitle class="subhead font-weight-light text-center my-5">¿Qué tipo de seguro estás buscando?</h2>
        <ng-container *ngIf="portalMode == 'CALLCENTER' || portalMode == 'F2F'">
          <app-searcher searchFormName="search-product" (searchEvent)="submitSearch($event)"></app-searcher>
          
          <app-f2f-selector *ngIf="portalMode == 'F2F' || portalMode == 'CALLCENTER'" [listData]="branches" [products]="productsHome" (dataEvent)="goToProduct($event.event, $event.data)"></app-f2f-selector>
        </ng-container>
        <ng-container *ngIf="portalMode == 'ECOMMERCE'">
          <ul class ="options-container">
            <li class="option-step" *ngFor="let branch of branches">
              <mat-card class="card-option" (click)="openBranch($event, branch)">
                <figure class="icon-container">
                  <img class="icon" [alt]="branch.Ramo_Name || ''" [ngSrc]="'../assets/img/portal/home-'+(branch.Icon || 'hospitalization.svg')" width="38" height="38">
                </figure>
                <p class="description">{{branch.Ramo_Name}}</p>
                <mat-icon class="arrow">keyboard_arrow_right</mat-icon>
              </mat-card>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>
  </mat-step>
  <mat-step completed="true">
    <div *ngIf="branchSelected">
      <div class="title-step">
        <p class="text-center h5">{{ branchSelected.Ramo_Name }}</p>
      </div>
      <section class="container container-portal">
        <h2 class="font-weight-light text-center subtitle-step">¿Qué tipo de protección estás buscando?</h2>
        <ul class ="options-container" *ngIf="subBranches">
          <li class="option-step" *ngFor="let branch of subBranches">
            <mat-card class="card-option" [appGATrackPath]="formatSpaces('/'+branchSelected.Ramo_Name+'/'+branch.name)" screen="Portal" (click)="openSubBranch(branch)">
              <figure class="icon-container">
                <img class="icon" [alt]="branch.name || ''" [ngSrc]="'../assets/img/portal/home-'+(branch.icon || 'hospitalization.svg')" width="38" height="38">
              </figure>
              <p class="description">{{branch.name}}</p>
              <mat-icon class="arrow">keyboard_arrow_right</mat-icon>
            </mat-card>
          </li>
        </ul>
        <div class="container d-flex justify-content-around">
          <button mat-button color="primary" [appGATrackPath]="formatSpaces('/'+branchSelected.Ramo_Name)" screen="Portal" class="back-button" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Regresar</button>
        </div>
      </section>
    </div>
  </mat-step>
  <mat-step completed="true">
    <div *ngIf="branchSelected">
      <div class="title-step">
        <p class="text-center h5">{{ branchSelected.Ramo_Name }}</p>
      </div>
      <section class="container container-portal">
        <h5 class="font-weight-light text-center my-3">Selecciona el tipo de seguro para conocer detalles y cotizar en solo segundos</h5>
        <ul class ="options-container container-products">
          <li class="option-product" *ngFor="let prod of productsFromSubBranch"  [ngClass]="{'four-product': productsFromSubBranch.length == 4}">
            <mat-card class="card-product">
              <div class="card-img-mask mat-card-image">
                <img [ngSrc]="'../assets/img/'+prod.icon" width="38" height="38" [alt]="prod.name">
              </div>
              <mat-card-content>
                <h5 class="text-center font-weight-normal">{{prod.name}}</h5>
                <div class="product-desc" [innerHTML]="prod.description"></div>
              </mat-card-content>
              <mat-card-actions class="d-flex flex-column align-items-center">
                <button  mat-flat-button color="accent" class="button-conoce cta-button" (click)="goToLanding($event, prod)"><a>Conoce más detalles &nbsp;&nbsp;&nbsp;</a><mat-icon>arrow_forward</mat-icon></button>
              </mat-card-actions>
            </mat-card>
          </li>
        </ul>
        <div class="container d-flex justify-content-around">
          <button mat-button color="primary" class="back-button" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Regresar</button>
        </div>
      </section>
    </div>
  </mat-step>
  <mat-step completed="true">
    <div *ngIf="branchSelected">
      <div class="title-step">
        <p class="text-center h5">{{ branchSelected.Ramo_Name }}</p>
      </div>
      <swiper class="carousel-container" [config]="configSwiper">
        <ng-container *ngIf="subBranchSelected?.name == 'En caso de fallecimiento por cualquier causa'">
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/interesting-icon.png" />
                  <h2 class="plan-title">Vida + Salud</h2>
                  <h3 class="plan-subtitle">Mejores beneficios</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes hasta:</p>
                    <p class="plan-price-amount">$<strong>{{amountCompare}}</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $15.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3">incluye</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3">ilimitada</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3">$50.00</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3">incluye</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/salud-vida-assist" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToPlans($event, 'SALUDA')" mat-flat-button color="accent" class="cta-button">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/better-icon.png" />
                  <h2 class="plan-title">Vida Exclusiva</h2>
                  <h3 class="plan-subtitle">Mayor Cobertura</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes hasta:</p>
                    <p class="plan-price-amount">$<strong>55.11</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $100.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3">Hasta $180 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/vida-exclusiva" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['VIDAEX', 'VIMENT'] })" mat-flat-button color="accent" class="cta-button">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/price-icon.png" />
                  <h2 class="plan-title">Seguro de Vida</h2>
                  <h3 class="plan-subtitle">Mejor Precio</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes desde:</p>
                    <p class="plan-price-amount">$<strong>7.69</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $50.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3">Hasta $25.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3">Hasta $7.500</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3">Hasta $25.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3">incluye</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3">incluye</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/seguro-de-vida" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['SEVMEN', 'SEVIAN'] })" mat-flat-button color="accent" class="cta-button">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
        </ng-container>
        <ng-container *ngIf="subBranchSelected?.name == 'Ver todas las opciones'">
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/interesting-icon.png" />
                  <h2 class="plan-title">Vida + Salud</h2>
                  <h3 class="plan-subtitle">Mejores beneficios</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes hasta:</p>
                    <p class="plan-price-amount">$<strong>{{amountCompare}}</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $15.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3">incluye</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3">ilimitada</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3">$50.00</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3">incluye</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/salud-vida-assist" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToPlans($event, 'SALUDA')" mat-flat-button color="accent" class="cta-button">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/better-icon.png" />
                  <h2 class="plan-title">Vida Exclusiva</h2>
                  <h3 class="plan-subtitle">Mayor Cobertura</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes hasta:</p>
                    <p class="plan-price-amount">$<strong>55.11</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $100.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3">Hasta $180 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/vida-exclusiva" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['VIDAEX', 'VIMENT'] })" mat-flat-button color="accent">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/price-icon.png" />
                  <h2 class="plan-title">Seguro de Vida</h2>
                  <h3 class="plan-subtitle">Mejor Precio</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes desde:</p>
                    <p class="plan-price-amount">$<strong>7.69</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $50.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3">Hasta $25.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3">Hasta $7.500</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3">Hasta $25.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3">incluye</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3">incluye</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/seguro-de-vida" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['SEVMEN', 'SEVIAN'] })" mat-flat-button color="accent">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon icon-search" alt="" src="../assets/img/portal/search.svg" />
                  <h2 class="plan-title">Hospi Seguro</h2>
                  <h3 class="plan-subtitle">Tal vez te puede interesar</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes desde:</p>
                    <p class="plan-price-amount">$<strong>22.00</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3">Hasta $200.00 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3">Hasta $400.00 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3">Hasta $600.00 diarios</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/seguro-de-vida" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['SEVMEN', 'SEVIAN'] })" mat-flat-button color="accent">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
        </ng-container>
        <ng-container *ngIf="subBranchSelected?.name == 'Hospitalización por enfermedad  o accidente'">
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/price-icon.png" />
                  <h2 class="plan-title">Hospi Seguro</h2>
                  <h3 class="plan-subtitle">Tal vez te puede interesar</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes desde:</p>
                    <p class="plan-price-amount">$<strong>22.00</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3">Hasta $200.00 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3">Hasta $400.00 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3">Hasta $600.00 diarios</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/seguro-de-vida" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['SEVMEN', 'SEVIAN'] })" mat-flat-button color="accent">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
          <div class="carousel-slide">
            <section class="card-container mx-auto mt-4">
              <mat-card class="plan-card-select">
                <mat-card-title class="plan-title-container bg-compare-blue">
                  <img class="plan-icon" alt="" src="../assets/img/portal/better-icon.png" />
                  <h2 class="plan-title">Vida Exclusiva</h2>
                  <h3 class="plan-subtitle">Mayor Cobertura</h3>
                </mat-card-title>
                <mat-card-content class="plan-content">
                  <div class="plan-price-container bg-light-cyan">
                    <p class="plan-price-time">Planes hasta:</p>
                    <p class="plan-price-amount">$<strong>55.11</strong> / al mes</p>
                  </div>
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Coberturas</th>
                        <th class="px-3">Suma asegurada</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">En caso de Muerte por cualquier causa</td>
                        <td class="px-3">Hasta $100.000</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Hospitalización por accidente</td>
                        <td class="px-3">Hasta $180 diarios</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de Muerte accidental</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Gastos médicos por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Indemnización por incapacidad total y permanente por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización por accidente</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en el extranjero</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">En caso de hospitalización en USA y Canadá</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr class="plan-divider" />
                  <table class="plan-table mt-4">
                    <thead>
                      <tr>
                        <th class="px-3">Asistencias médicas</th>
                        <th class="px-3">Detalle</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="px-3">2 Consultas médicas al mes en diferentes especialidades</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Telemedicina</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Ambulancia por emergencia</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                      <tr>
                        <td class="px-3">Laboratorio clínicos y más...</td>
                        <td class="px-3 no-include">x</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan-cta-container">
                    <a href="#" routerLink="/vida-exclusiva" class="plan-details-link mb-3">Conoce más detalles de este seguro</a>
                    <button (click)="goToProduct($event, { relatedProducts:['VIDAEX', 'VIMENT'] })" mat-flat-button color="accent">Explora planes <mat-icon>arrow_forward</mat-icon></button>
                  </div>
                </mat-card-content>
              </mat-card>
            </section>
          </div>
        </ng-container>

      </swiper>
      <div class="container d-flex justify-content-around">
        <button mat-button color="primary" class="back-button" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Regresar</button>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
<ng-container *ngIf="portalMode == 'ECOMMERCE'">
  <section class="bg-video video-section">
    <div class="container container-video">
      <h1
        style="padding: 55px 30px 30px 20px"
        class="font-weight-light text-center my-1"
      >
        Más de 240 mil clientes Banco Guayaquil ya eligieron a Chubb Seguros para
        estar protegidos
      </h1>
      <div
        style="padding: 0px 30px 30px 20px; text-align: center"
        class="roboto-light"
      >
        Conoce el beneficio de estar asegurado desde la experiencia de otras
        personas
      </div>
      <div class="video-container">
        <iframe
          id="video-chubb-player"
          title="Reproductor de video de promocional de Chubb Seguros"
          style="border-radius: 10px"
          class="video"
          src="https://players.brightcove.net/818971943001/default_default/index.html?videoId=6274909867001"
          allow="geolocation; encrypted-media"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </section>
  <section style="background: #ffffff">
    <div class="container">
      <div
        class="roboto-light font-color"
        style="
          font-size: 1.7em;
          padding: 2em 1em;
          padding-bottom: 1em;
          text-align: center;
        "
      >
        Una alianza estratégica que te mantendrá seguro
      </div>
      <div
        class="roboto-light font-color"
        style="padding: 0 2.1em; padding-bottom: 3em; text-align: center"
      >
        Nuestro socio estratégico Chubb Seguros es una empresa internacional con la
        capacidad de cuidar lo más importante que tenemos: nuestros clientes.
      </div>
      <div style="text-align: center; padding-bottom: 2em">
        <img ngSrc="../../../../../assets/svg/logo-chubb-blue.svg" width="138" height="14" alt="Logo de Chubb" />
      </div>
      <div
        class="roboto-light font-color"
        style="padding: 0 2.1em; padding-bottom: 3em; text-align: center"
      >
        Chubb Seguros es una de las más grandes aseguradoras presente en el mercado
        ecuatoriano con una amplia gama de productos personales.
      </div>
    </div>
  </section>
  <section style="background-color: #ffffff">
    <div class="container">

      <ul class="company-specs">
        <li class="company-specs-item" style="padding-bottom: 2em">
          <div style="text-align: center; padding: 2em 0">
            <img ngSrc="../../../../../assets/img/Ecommerce3/world_icon.svg" width="95" height="95" alt="Ilustración del planeta Tierra" />
          </div>
          <div
            class="roboto-regular"
            style="
              color: #000000;
              font-size: 1.2em;
              font-weight: 600;
              text-align: center;
              padding: 0 2em;
            "
          >
            Aseguradora internacional, con operación en más de 54 países.
          </div>
        </li>
        <li class="company-specs-item" style="padding-bottom: 2em">
          <div style="text-align: center; padding: 2em 0">
            <img ngSrc="../../../../../assets/img/Ecommerce3/shield_icon.svg" width="95" height="95" alt="Ilustración de escudo con visto, simbolo de excelencia" />
          </div>
          <div
            class="roboto-regular"
            style="
              color: #000000;
              font-size: 1.2em;
              font-weight: 600;
              text-align: center;
              padding: 0 1em;
            "
          >
            Chubb es la aseguradora comercial más grande de los Estados Unidos.
          </div>
        </li>
        <li class="company-specs-item" style="padding-bottom: 2em">
          <div style="text-align: center; padding: 2em 0">
            <img ngSrc="../../../../../assets/img/Ecommerce3/medal_icon.svg" width="95" height="95"  alt="Ilustración de medalla, simbolo de ser de los mejores en el mercado" />
          </div>
          <div
            class="roboto-regular"
            style="
              color: #000000;
              font-size: 1.2em;
              font-weight: 600;
              text-align: center;
              padding: 0 2em;
            "
          >
            Calificación de riesgo AAA en fortaleza financiera.
          </div>
        </li>
      </ul>
      <div class="plan-cta-container" style="padding-bottom: 1em">
        <a
          href="https://www.chubb.com/ec-es/"
          target="_blank"
          class="about-us-btn"
          mat-flat-button
          color="accent"
          (click)="goToChubb($event)"
        >
          Conoce más de Chubb
          <mat-icon>arrow_forward</mat-icon>
      </a>
        <div style="padding: 3em;" class="roboto-regular">
          <a (click)="scrollToTypeTitle($event, typeTitle)" style="color: #008BF0; text-decoration: underline;">
            ¿Ya estás listo para elegir tu seguro?
          </a>
        </div>
      </div>
    </div>
  </section>
</ng-container>
<app-modal-legacy></app-modal-legacy>
<app-home-icon [ngClass]="{'d-none': homestepper.selectedIndex < 0 }"></app-home-icon>